module.exports = __webpack_public_path__ + "img/dl_icon.873c21d1.svg";